<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-05-10 13:17:54
 * @FilePath: \mrc-ess-fronted\src\Layout\components\Announcement.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-21 13:32:53
-->
<template>
  <v-sheet
    class="mx-n3 mt-n3 transparent black--text rounded-lg"
    v-show="desserts.length > 0"
    v-if="$route.path === '/dashboard' && $vuetify.breakpoint.name != 'xs'"
  >
    <v-carousel
      cycle
      height="115"
      :show-arrows="false"
      hide-delimiter-background
      delimiter-icon="mdi-circle"
    >
      <v-carousel-item
        v-for="(announecment, i) in desserts"
        :key="`announecment---${i}`"
      >
        <v-sheet height="100%" color="#FDF3CD">
          <v-row dense class="fill-height" align="center" justify="center">
            <div
              class="text-decoration-underline text-body-1 text--primary"
              @click="toView(announecment.uuid)"
            >
              {{ announecment.message_title }}
            </div>
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
    <viewAnnouncement
      :show="showDetail"
      canEdit
      :curUuid="curUuid"
      @close="
        showDetail = false;
        curUuid = null;
      "
    />
  </v-sheet>
</template>
<script>
import { mapGetters } from "vuex";
import viewAnnouncement from "@/Page/Ess/Announcement/components/viewAnnouncement";
export default {
  name: "dashboard_Announcement",
  components: { viewAnnouncement },
  props: {},
  computed: {},
  watch: {
    desserts(val) {
      this.$emit("hasAnnouncement", val);
    },
  },
  data() {
    return { desserts: [], showDetail: false, curUuid: null, isRead: false };
  },
  mounted() {
    this.getList();
  },
  methods: {
    toView: function (uuid) {
      this.curUuid = uuid;
      this.showDetail = true;
    },
    getList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "mrbase_sys_announcement",
        url: "/home-page/get-announcement/",
        type: "client",
        notAlert: true,
      }).then((res) => {
        that.desserts = res.data;
      });
    },
  },
};
</script>
<style >
.v-carousel__controls__item .v-icon {
  font-size: 9px !important;
}
.v-carousel__controls__item.v-btn::before {
  background-color: transparent !important;
}
</style>